import { Fragment } from "react";
import { FormProvider } from "../FormContext";
import { useParams } from "react-router-dom";
import ServiceSwitch from "../../components/ServiceSwitch";

const DeliveryFormWrapper = () => {
    const { type, payment_type } = useParams();
    return <Fragment>
        <FormProvider type={type} payment_type={payment_type}>
            <ServiceSwitch type={type} payment_type={payment_type}/>
        </FormProvider>
    </Fragment>
}

export default DeliveryFormWrapper;